import LogoSpinner from 'shared/components/spinners/logo/LogoSpinner';
import {observer} from 'mobx-react';
import {UserActivationState} from '../state';
import {withState} from 'shared/core';
import {FormattedMessage} from 'react-intl';

const UserActivation = observer(() => {
  return (
    <div>
      <div className='mx-auto bg-white box-shadow-1 rounded' style={{width: '650px'}}>
        <div className='h2 mt4 pt3 center'>
          <FormattedMessage id='user_activation.Activating your account...'/>
        </div>
        <div className='waterloo mt1 center'>
          <FormattedMessage id='user_activation.Please wait while we set things up.'/>
        </div>
        <div className='relative mx-auto' style={{height: '255px'}}>
          <LogoSpinner height='120' width='54' animate={true}/>
        </div>
      </div>
    </div>
  );
});

export default withState(UserActivation, UserActivationState);
